async function getPublicDatav(path, period = 'day', dateRange = null, extraParams = null) {
  const params = new URLSearchParams()
  params.set('period', period || 'day')
  if (dateRange && dateRange.startDate) {
    params.set('startDate', dateRange.startDate)
  }
  if (dateRange && dateRange.endDate) {
    params.set('endDate', dateRange.endDate)
  }
  if (extraParams && typeof extraParams === 'object') {
    Object.keys(extraParams).forEach(key => {
      const value = extraParams[key]
      if (value !== undefined && value !== null && value !== '') {
        params.set(key, value)
      }
    })
  }

  const response = await fetch(`/prod-api/public/datav/${path}?${params.toString()}`, {
    headers: {
      Accept: 'application/json'
    }
  })

  if (!response.ok) {
    throw new Error(`大屏数据请求失败：${response.status}`)
  }

  const result = await response.json()

  if (result.code !== 200) {
    throw new Error(result.msg || '大屏数据返回异常')
  }

  return result.data || {}
}

export async function getAdminUrl() {
  const requestUrl = '/prod-api/public/datav/admin-url'
  console.info('[datav-admin-url] 开始请求后台地址', {
    requestUrl,
    pageUrl: window.location.href,
    origin: window.location.origin
  })

  const response = await fetch(requestUrl, {
    headers: {
      Accept: 'application/json'
    }
  })

  console.info('[datav-admin-url] 接口响应状态', {
    requestUrl,
    ok: response.ok,
    status: response.status,
    statusText: response.statusText,
    finalUrl: response.url
  })

  if (!response.ok) {
    throw new Error(`后台地址请求失败：${response.status}`)
  }

  const result = await response.json()
  console.info('[datav-admin-url] 接口响应内容', result)

  if (result.code !== 200) {
    throw new Error(result.msg || '后台地址返回异常')
  }

  const rawAdminUrl = result.data !== undefined && result.data !== null
    ? result.data
    : result.msg
  const adminUrl = normalizeAdminUrl(rawAdminUrl)
  console.info('[datav-admin-url] 地址清洗结果', {
    raw: rawAdminUrl,
    normalized: adminUrl
  })
  return adminUrl
}

function normalizeAdminUrl(value) {
  if (!value) {
    return ''
  }
  let url = typeof value === 'string' ? value : String(value)
  url = url.trim()

  try {
    const parsed = JSON.parse(url)
    if (typeof parsed === 'string') {
      url = parsed.trim()
    }
  } catch (error) {
    // 兼容缓存里直接存普通字符串的情况
  }

  while (url.length >= 2 && url.startsWith('"') && url.endsWith('"')) {
    url = url.slice(1, -1).trim()
  }
  return url.replace(/\\\//g, '/')
}

export function getLeftFormChart(period, dateRange) {
  return getPublicDatav('left/form', period, dateRange)
}

export function getLeftGoodsChart(period, dateRange) {
  return getPublicDatav('left/goods', period, dateRange)
}

export function getLeftFreightChart(period, dateRange) {
  return getPublicDatav('left/freight', period, dateRange)
}

export function getLeftTaxationChart(period, dateRange) {
  return getPublicDatav('left/taxation', period, dateRange)
}

export function getLeftTransportationChart(period, dateRange) {
  return getPublicDatav('left/transportation', period, dateRange)
}

export function getLeftRailwayChart(period, dateRange) {
  return getPublicDatav('left/railway', period, dateRange)
}

export function getWlOverview(period, dateRange) {
  return getPublicDatav('wl/overview', period, dateRange)
}

export function getWlMiddleChart(period, dateRange) {
  return getPublicDatav('wl/middle', period, dateRange)
}

export function getWlTerritoryChart(period, dateRange) {
  return getPublicDatav('wl/territory', period, dateRange)
}

export function getWlPassengerChart(period, dateRange) {
  return getPublicDatav('wl/passenger', period, dateRange)
}

export function getBondedOverview(period, dateRange, pagination) {
  return getPublicDatav('bonded/overview', period, dateRange, pagination)
}

export function getLeftBusinessYesChart(period, dateRange) {
  return getPublicDatav('left/business-yes', period, dateRange)
}

export function getLeftBusinessNoChart(period, dateRange) {
  return getPublicDatav('left/business-no', period, dateRange)
}

export function getLeftMarketChart(period, dateRange) {
  return getPublicDatav('left/market', period, dateRange)
}

export function getLeftBarterChart(period, dateRange) {
  return getPublicDatav('left/barter', period, dateRange)
}

export function getRightMiddleChart(period, dateRange) {
  return getPublicDatav('right/middle', period, dateRange)
}

export function getRightTerritoryChart(period, dateRange) {
  return getPublicDatav('right/territory', period, dateRange)
}

export function getCenterFilingChart(period, dateRange) {
  return getPublicDatav('center/filing', period, dateRange)
}

export function getCenterTopOnDuty() {
  return getPublicDatav('center/top/on-duty')
}

export function getCenterTopMaps() {
  return getPublicDatav('center/top/maps')
}

export function getCenterTopIcons() {
  return getPublicDatav('center/top/icons')
}

export function getCenterTradeRows(period, dateRange) {
  return getPublicDatav('center/trade', period, dateRange)
}

export function getCenterGoodsTop(period, dateRange) {
  return getPublicDatav('center/goods', period, dateRange)
}

export function getCenterFourRows(period, dateRange) {
  return getPublicDatav('center/four', period, dateRange)
}

export function getCenterWarningPage(type, dateRange, pagination) {
  return getPublicDatav('center/warnings', 'day', dateRange, { type, ...pagination })
}

export function getCenterTimeRows(period, dateRange) {
  return getPublicDatav('center/time', period, dateRange)
}

export function getCenterAbnormalRows(period, dateRange) {
  return getPublicDatav('center/abnormal', period, dateRange)
}

export function getCenterSamplingRows(period, dateRange) {
  return getPublicDatav('center/sampling', period, dateRange)
}

export function getRightLawRows(period, dateRange) {
  return getPublicDatav('right/law', period, dateRange)
}

export function getRightDutyRows(period, dateRange) {
  return getPublicDatav('right/duty', period, dateRange)
}

export function getRightQuarantineRows(period, dateRange) {
  return getPublicDatav('right/quarantine', period, dateRange)
}

export function getRightTransferSummary(period, dateRange) {
  return getPublicDatav('right/transfer', period, dateRange)
}

export function getRightUseSummary(period, dateRange) {
  return getPublicDatav('right/use', period, dateRange)
}

export function getRightGrainChart(period, dateRange) {
  return getPublicDatav('right/grain', period, dateRange)
}

export function getRightWorkRows(period, dateRange) {
  return getPublicDatav('right/work', period, dateRange)
}

export async function listStatisticsData(payload) {
  const response = await fetch('/prod-api/public/datav/statistics/list', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload || {})
  })

  if (!response.ok) {
    throw new Error(`统计数据请求失败：${response.status}`)
  }

  return response.json()
}

export async function exportStatisticsData(payload) {
  const response = await fetch('/prod-api/public/datav/statistics/export', {
    method: 'POST',
    headers: {
      Accept: 'application/octet-stream',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload || {})
  })

  if (!response.ok) {
    throw new Error(`统计数据导出失败：${response.status}`)
  }

  const blob = await response.blob()
  const disposition = response.headers.get('content-disposition') || ''
  const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i)
  const filename = match ? decodeURIComponent(match[1].replace(/"/g, '')) : '大屏统计数据.xlsx'

  return { blob, filename }
}

export async function exportStatisticsSummary(payload) {
  const response = await fetch('/prod-api/public/datav/statistics/summary-export', {
    method: 'POST',
    headers: {
      Accept: 'application/zip',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload || {})
  })

  if (!response.ok) {
    throw new Error(`数据汇总导出失败：${response.status}`)
  }

  const blob = await response.blob()
  const disposition = response.headers.get('content-disposition') || ''
  const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i)
  const filename = match ? decodeURIComponent(match[1].replace(/"/g, '')) : '数据汇总.zip'

  return { blob, filename }
}

async function getPublicYjList(type, pageNum = 1, pageSize = 5) {
  const params = new URLSearchParams({
    pageNum: String(pageNum),
    pageSize: String(pageSize)
  })
  const response = await fetch(`/prod-api/public/yj/${type}?${params.toString()}`, {
    headers: { Accept: 'application/json' }
  })
  if (!response.ok) {
    throw new Error(`预警数据请求失败：${response.status}`)
  }
  const result = await response.json()
  if (![0, 200].includes(Number(result.code))) {
    throw new Error(result.msg || '预警数据返回异常')
  }
  return {
    rows: Array.isArray(result.rows) ? result.rows : [],
    total: Number(result.total) || 0
  }
}

export function getYjBusinessList(pageNum, pageSize) {
  return getPublicYjList('business', pageNum, pageSize)
}

export function getYjChangeList(pageNum, pageSize) {
  return getPublicYjList('change', pageNum, pageSize)
}

export function getYjRectificationList(pageNum, pageSize) {
  return getPublicYjList('rectification', pageNum, pageSize)
}

async function requestYjWorkflow(path, payload, method = 'POST') {
  const headers = {
    Accept: 'application/json',
    Authorization: `Bearer ${getToken()}`
  }
  const options = {
    method,
    headers
  }
  if (payload !== undefined) {
    headers['Content-Type'] = 'application/json'
    options.body = JSON.stringify(payload)
  }
  const response = await fetch(`/prod-api/yj/workflow/${path}`, {
    ...options
  })
  const result = await response.json().catch(() => ({}))
  if (!response.ok || Number(result.code) !== 200) {
    throw new Error(result.msg || `预警处置请求失败：${response.status}`)
  }
  return result.data
}

export function addYjLeaderInstruction(type, id, instruction) {
  return requestYjWorkflow(`${type}/${id}/leader-instruction`, { instruction })
}

export function deleteYjLeaderInstruction(type, id, index) {
  return requestYjWorkflow(`${type}/${id}/leader-instruction/${index}`, undefined, 'DELETE')
}

export function addYjDepartmentHandling(type, id, payload) {
  return requestYjWorkflow(`${type}/${id}/department-handling`, payload)
}

export async function uploadYjAttachment(file) {
  const formData = new FormData()
  formData.append('file', file)
  const response = await fetch('/prod-api/common/upload', {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}` },
    body: formData
  })
  const result = await response.json().catch(() => ({}))
  if (!response.ok || Number(result.code) !== 200) {
    throw new Error(result.msg || `附件上传失败：${response.status}`)
  }
  return result
}
import { getToken } from '@/utils/auth'
